import { Group, ActionIcon, Text } from '@mantine/core';
import { IconStar, IconStarFilled, IconStarHalfFilled } from '@tabler/icons-react';

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showValue?: boolean;
  onChange?: (rating: number) => void;
  readonly?: boolean;
}

const sizes = {
  xs: 14,
  sm: 18,
  md: 22,
  lg: 28,
};

export function StarRating({
  rating,
  maxRating = 5,
  size = 'md',
  showValue = false,
  onChange,
  readonly = true,
}: StarRatingProps) {
  const iconSize = sizes[size];
  const color = 'var(--mantine-color-yellow-5)';

  const handleClick = (value: number) => {
    if (!readonly && onChange) {
      onChange(value);
    }
  };

  const stars = [];
  for (let i = 1; i <= maxRating; i++) {
    const diff = rating - i + 1;
    let StarIcon = IconStar;

    if (diff >= 1) {
      StarIcon = IconStarFilled;
    } else if (diff >= 0.5) {
      StarIcon = IconStarHalfFilled;
    }

    if (readonly) {
      stars.push(
        <StarIcon
          key={i}
          size={iconSize}
          color={diff > 0 ? color : 'var(--mantine-color-gray-4)'}
          fill={diff > 0 ? color : 'none'}
        />
      );
    } else {
      stars.push(
        <ActionIcon
          key={i}
          variant="transparent"
          onClick={() => handleClick(i)}
          style={{ cursor: 'pointer' }}
          size={iconSize + 8}
        >
          <StarIcon
            size={iconSize}
            color={i <= rating ? color : 'var(--mantine-color-gray-4)'}
            fill={i <= rating ? color : 'none'}
          />
        </ActionIcon>
      );
    }
  }

  return (
    <Group gap={2}>
      {stars}
      {showValue && (
        <Text size={size} fw={500} ml={4}>
          {rating.toFixed(1)}
        </Text>
      )}
    </Group>
  );
}
